import { AdditionalCostType } from 'types/additional-cost';

export const tripAdditionalCostTypes = {
  warehouse_cost: AdditionalCostType.warehouse_cost,
  partners_warehouse_cost: AdditionalCostType.partners_warehouse_cost,
  other: AdditionalCostType.other,
};
